import RedCross from '../../assets/icons/red-cross.svg';
import GreenCross from '../../assets/icons/green-cross.svg';
import YellowCross from '../../assets/icons/yellow-cross.svg';
import BlueCross from '../../assets/icons/blue-cross.svg';
import GreyCross from '../../assets/icons/grey-cross.svg';
import DefaultIcon from '../../assets/icons/defaultIcon.svg';

type AlertColor = 'success' | 'error' | 'warning' | 'info' | 'open';

export const getCloseIcon = (color: AlertColor, customIcon?: React.ReactNode) => {
  if (customIcon) {
    return customIcon;
  }
  switch (color) {
    case 'success':
      return <GreenCross />;
    case 'error':
      return <RedCross />;
    case 'warning':
      return <YellowCross />;
    case 'info':
      return <BlueCross />;
    case 'open':
      return <GreyCross />;
    default:
      return <DefaultIcon />;
  }
};
